import axios from '../../helpers/axios-setup';

export const getImpersonationUsers = (companyId: number) =>
  axios.get(`/staff/impersonate/companies/${companyId}/users`);
